import React from 'react';
import useMoment from '../../hooks/useMoment';

function LetterDateBottom({ date, fontSize = 28 }) {
    const { paperSolarDateString, paperLunarDateString, dateNow } = useMoment();
    const fromDate = date || dateNow();

	return (
		<div style={{ textAlign: "center", padding: "0.4em 0.3em", paddingBottom:40 }}>
			<p style={{ fontSize, fontFamily: "KhmerOSSiemreap", margin: 0 }}>{paperLunarDateString(fromDate)}</p>
			<p style={{ fontSize, fontFamily: "KhmerOSSiemreap", margin: 0 }}>{paperSolarDateString(fromDate)}</p>
			<p style={{ fontSize, fontFamily: "KhmerOSMuolLight", margin: 0 }}>អគ្គនាយក</p>
			<p style={{ fontSize, fontFamily: "KhmerOSMuolLight", margin: 0 }}>និយ័តករធានារ៉ាប់រងកម្ពុជា</p>
		</div>
	);
}

export default LetterDateBottom;
